<template>
  <div
    v-if="show"
    class="absolute top-[-10px] right-[-12px] z-10 transition-all w-max"
  >
    <div
      class="bg-black rounded-lg pb-2.5 min-w-[132px] max-h-96 overflow-overlay"
      :class="[!props.search ? 'py-2.5' : '']"
    >
      <div v-if="search" class="pt-2.5 sticky top-0 bg-black">
        <div
          class="py-2 px-3 flex justify-between items-center border-y-2 border-[#FFF]/20"
          @click.stop
        >
          <icon
            icon="search.svg"
            fill="none"
            :width="20"
            :height="20"
            class="mr-2"
          ></icon>
          <input
            v-model="searchText"
            placeholder="搜索"
            class="text-white bg-transparent border-none outline-none"
          />
        </div>
      </div>

      <template v-if="filterOptions.length">
        <div
          v-for="item in filterOptions"
          :key="item.value + item.label"
          class="px-4 h-10 hover:bg-black-active flex items-center justify-between"
          :class="{
            ' attr-disabled': item.disabled
          }"
          data-is-option="true"
          @click.stop="() => !item.disabled && onSelect(item.value)"
        >
          <span
            class="text-white text-sm flex-shrink-0"
            :class="{
              'font-medium': item.value == value
            }"
            >{{ item.label }}</span
          >
          <icon
            class="ml-4 opacity-0"
            :class="{
              'opacity-100': item.value == value
            }"
            icon="selected.svg"
            :width="14"
            :height="14"
            fill="none"
          />
        </div>
      </template>
      <template v-else>
        <div class="h-14 flex items-center justify-center opacity-70">
          暂无内容
        </div>
      </template>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { PropType, onBeforeMount, onMounted, ref, watch } from 'vue';
import { debounce } from 'lodash-es';

const props = defineProps({
  value: {
    type: [String, Number, Boolean] as PropType<string | number | boolean>,
    default: undefined
  },
  options: {
    type: Array as PropType<
      {
        label: string;
        value: string | number | boolean;
        disabled?: boolean;
      }[]
    >,
    default: () => []
  },
  search: {
    type: Boolean,
    default: false
  }
});

// 过滤后的options
const filterOptions = ref(props.options);
const searchText = ref('');
// 监听搜索文本变化
watch(
  () => ({
    options: props.options,
    searchText: searchText.value
  }),
  debounce((newVal) => {
    const options = newVal.options as {
      label: string;
      value: string | number | boolean;
    }[];
    if (!newVal.searchText) {
      filterOptions.value = options;
      return;
    }
    filterOptions.value = options.filter(
      (option) => option.label.indexOf(newVal.searchText) > -1
    );
  }, 10)
);

defineExpose({
  open: () => {
    show.value = true;
  }
});

const emit = defineEmits<{
  (event: 'change', val: typeof props.value): void;
}>();
const onSelect = (v: typeof props.value) => {
  if (v != props.value) emit('change', v);
  show.value = false;
};

const show = ref(false);
const close = (e: Event) => {
  if (!show.value) return;
  show.value = !!(e.target as HTMLDivElement).dataset?.['isOption'];
  // 清空搜索框
  searchText.value = '';
};

onMounted(() => {
  window.addEventListener('click', close);
});
onBeforeMount(() => {
  window.removeEventListener('click', close);
});
</script>

<style lang="less" scoped>
// :deep() {
// }
</style>
